/**
 * Created by Alex Aguilar on 7/7/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('adminFlightAllCtrl', adminFlightAllCtrl)

    adminFlightAllCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'dateService', 'linkService', 'tabAdminFlights',
        'modelAircraftFlights', 'aircraftFlights'];

    function adminFlightAllCtrl($scope, $timeout, $stateParams, dateService, linkService, tabAdminFlights,
                                modelAircraftFlights, aircraftFlights){
        var vm = this;
        vm.grid = {};
        vm.tabs = tabAdminFlights;
        vm.radioFlight = 'grid';
        var arrayModelAircrafts = generateArrayScheduleModelAircraft(modelAircraftFlights, dateService, linkService);
        var arrayAircrafts = generateArrayScheduleAircraft(aircraftFlights, dateService, linkService);
        vm.arraySchedule = arrayModelAircrafts.concat(arrayAircrafts)

        vm.changeGridDay = function(date){
            $timeout(function(){
                var dateTime = dateService.getDateToTime(vm.grid.date);
                linkService.reloadRoute('adminFlightAll', {date: dateTime});
            }, 500);
        }
    }

    function generateArrayScheduleModelAircraft(modelAircrafts, dateService, linkService){
        var arraySchedule = [],
            arrayScheduleNames = [];

        angular.forEach(modelAircrafts, function(modelAircraft, key){
            var posName = arrayScheduleNames.indexOf(modelAircraft.name),
                scheduleName = modelAircraft.name;
            if(posName !== -1){
                scheduleName = "";
            }
            arrayScheduleNames.push(modelAircraft.name);
            arraySchedule.push({'name': scheduleName, 'appointments': []});
            angular.forEach(modelAircraft._embedded.flights, function(flight){
                angular.forEach(flight._embedded.departureflights, function(departureFlight){
                    var dateStart = new Date(parseInt(departureFlight.departureDate)),
                        dateEnd = new Date(parseInt(departureFlight.arrivalDate)),
                        departureDateTime = dateService.convertTimeToZero(dateStart.getHours(), dateStart.getMinutes()),
                        arrivalDateTime = dateService.convertTimeToZero(dateEnd.getHours(), dateEnd.getMinutes()),
                        segmentRoute = departureFlight._embedded.segment.name;

                    segmentRoute = segmentRoute.replace(/[ ]/g, "");
                    segmentRoute = segmentRoute.split('-');

                    arraySchedule[key].appointments.push({
                        'start': departureDateTime,
                        'end': arrivalDateTime,
                        'title': flight.flightNumber,
                        'class': 'nonsense',
                        'flightId': linkService.getLinkId(flight._links.self.href),
                        'flightNumber': flight.flightNumber,
                        'route': segmentRoute[0] + '-' + segmentRoute[1],
                        'startRoute': segmentRoute[0],
                        'endRoute': segmentRoute[1],
                        'payload': {}
                    });
                });
            });
        });

        var newAppointments = [];
        angular.forEach(arraySchedule, function(schedule, indexSchedule){
            newAppointments.push({
                "name": schedule.name,
                "appointmentsOne": [],
                "appointmentsTwo":[],
                "appointmentsThree":[],
                "appointmentsFour":[],
                "appointmentsFive":[],
                "appointmentsSix":[]
            })
            angular.forEach(schedule.appointments, function(appointment, index){
                if(index == 0){
                    newAppointments[indexSchedule].appointmentsOne.push(appointment);
                }else{
                    var exits = checkObjectRange(newAppointments[indexSchedule].appointmentsOne, appointment);
                    if(!exits){
                        newAppointments[indexSchedule].appointmentsOne.push(appointment);
                    }else{
                        var exitsTwo = checkObjectRange(newAppointments[indexSchedule].appointmentsTwo, appointment);
                        if(!exitsTwo){
                            newAppointments[indexSchedule].appointmentsTwo.push(appointment);
                        }else{
                            var exitsThree = checkObjectRange(newAppointments[indexSchedule].appointmentsThree, appointment);
                            if(!exitsThree){
                                newAppointments[indexSchedule].appointmentsThree.push(appointment);
                            }else{
                                var exitsFour = checkObjectRange(newAppointments[indexSchedule].appointmentsFour, appointment);
                                if(exitsFour){
                                    newAppointments[indexSchedule].appointmentsFour.push(appointment);
                                }else{
                                    var exitsFive = checkObjectRange(newAppointments[indexSchedule].appointmentsFour, appointment);
                                    if(exitsFive){
                                        newAppointments[indexSchedule].appointmentsFive.push(appointment);
                                    }else{
                                        newAppointments[indexSchedule].appointmentsSix.push(appointment);
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });

        var result = [];
        angular.forEach(newAppointments, function(newAppointment) {
            result.push({
                "name": newAppointment.name,
                "appointments": newAppointment.appointmentsOne
            });

            if (newAppointment.appointmentsTwo.length > 0) {
                result.push({
                    "name": "",
                    "appointments": newAppointment.appointmentsTwo
                });
            }
            if(newAppointment.appointmentsThree.length > 0){
                result.push({
                    "name": "",
                    "appointments": newAppointment.appointmentsThree
                });
            }

            if(newAppointment.appointmentsFour.length > 0){
                result.push({
                    "name": "",
                    "appointments": newAppointment.appointmentsFour
                });
            }

            if(newAppointment.appointmentsFive.length > 0){
                result.push({
                    "name": "",
                    "appointments": newAppointment.appointmentsFive
                });
            }

            if(newAppointment.appointmentsSix.length > 0){
                result.push({
                    "name": "",
                    "appointments": newAppointment.appointmentsSix
                });
            }
        });

        return result;
    }

    function checkObjectRange(appointments, objectAppointment){
        var res = false,
            startObject = convertTimeToInteger(objectAppointment.start),
            endObject = convertTimeToInteger(objectAppointment.end);

        for(var i = 0; i < appointments.length; i++){
            var start = convertTimeToInteger(appointments[i].start);
            var end = convertTimeToInteger(appointments[i].end);
            if(startObject >= start && startObject <= end){
                res = true;
                break;
            }else if(endObject >= start && endObject <= end){
                res = true;
                break;
            }
        }
        return res;
    }

    function getKeyObject(object){
        return convertTimeToInteger(object.start) + "_" + object.flightNumber + "_" + convertTimeToInteger(object.end);
    }

    function convertTimeToInteger(time){
        var splitTime = time.split(":"),
            res = splitTime[0] +splitTime[1];
        return parseInt(res);
    }

    function generateArrayScheduleAircraft(aircraftFlights, dateService, linkService){
        var arraySchedule = [],
            arrayScheduleNames = [];

        angular.forEach(aircraftFlights, function(aircraftFlight, key){
            var posName = arrayScheduleNames.indexOf(aircraftFlight.plaque),
                scheduleName = aircraftFlight.plaque;
            if(posName !== -1){
                scheduleName = "";
            }
            arrayScheduleNames.push(aircraftFlight.plaque);
            arraySchedule.push({'name': scheduleName, 'appointments': []});

            angular.forEach(aircraftFlight._embedded.flights, function(flight){
                angular.forEach(flight._embedded.departureflights, function(departureFlight){
                    var dateStart = new Date(parseInt(departureFlight.departureDate)),
                        dateEnd = new Date(parseInt(departureFlight.arrivalDate)),
                        departureDateTime = dateService.convertTimeToZero(dateStart.getHours(), dateStart.getMinutes()),
                        arrivalDateTime = dateService.convertTimeToZero(dateEnd.getHours(), dateEnd.getMinutes()),
                        segmentRoute = departureFlight._embedded.segment.name;

                    segmentRoute = segmentRoute.replace(/[ ]/g, "");
                    segmentRoute = segmentRoute.split('-');

                    arraySchedule[key].appointments.push({
                        'start': departureDateTime,
                        'end': arrivalDateTime,
                        'title': flight.flightNumber,
                        'class': 'nonsense',
                        'flightId': linkService.getLinkId(flight._links.self.href),
                        'flightNumber': flight.flightNumber,
                        'route': segmentRoute[0] + '-' + segmentRoute[1],
                        'startRoute': segmentRoute[0],
                        'endRoute': segmentRoute[1],
                        'payload': {}
                    });
                });
            });
        });
        return arraySchedule;
    }
})();
